import styled from 'styled-components';

export const Content = styled.div`
  display: inline-flex;
  background: url(/images/loader2.svg) no-repeat 50% 50%;
  background-size: contain;
  width: 20px;
  height: 20px;
`;
